import http from '@/utils/request';
import global_ from '@/utils/Global'
let apiUrl = global_.BASE_URL;
let apiUrl_ZS = global_.BASE_URL_ZS;

//查询
export const getcolor = params => {
  return http.requestPost(apiUrl + 'User_theme/get_select_theme', params)
} 
//查询
export const get_by_id_lang_link = params => {
  return http.requestPost(apiUrl + 'system_config/get_by_id', params)
} 
export const get_get_font_style = params => {
  return http.requestPost(apiUrl_ZS + 'layout_model/get_select_config', params)
}


/*登录*/
export const loginPassword = params => {
  return http.requestPost(apiUrl_ZS + 'login/login', params)
}
// 判断根据验证图片的输入数字是否正确  
export const yanzhengyzmimgdata = params => {
  return http.requestPost(apiUrl_ZS + 'login/captcha', params)
}
// 切换验证图片  没有用到此接口  原因是暂时无法获取本地数据流图片 ，在页面中新写了一个请求方式  
export const nextyzmimgnext = params => {
  return http.requestPostDownload(apiUrl_ZS + 'login/captcha_img', params)
}

export const api = global_.BASE_URL_ZS

/**测试get */
export const getLabelById = params => {
  return http.requestGet(apiUrl + '/label/getById/' + params)
}



// WEBPACK FOOTER //
// ./src/components/page/Login/api/login.js